import { ModelBase } from 'store/model-base';

export class StatementCredit extends ModelBase {
    public static storeName: string = 'statementCredit';

    public creditAmount: number;
    public creditDescription: string;
    public creditType?: string;
    public creditContent?: string;
}
